// @flow
import 'styles/scss/shared.scss';
import React from 'react';
import styled from 'styled-components';
import { ScreenOverlay, ModalBody } from 'styles/Modals';

const ScreenOverlayCustom = styled(ScreenOverlay)`
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255,255,255, 0.5);
`;

const ScreenModalBody = styled(ModalBody)`
  margin: 0 auto;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -100px;
  margin-left: -150px;
`;

type PropsType = {
  show: boolean
}

export default function LoginLogo (props: PropsType) {
  const {show} = props;

  return (
    <ScreenOverlayCustom show={show}>
      <ScreenModalBody>
        <svg className="homie_logo loader"  viewBox="0 0 98 36" xmlns="http://www.w3.org/2000/svg">
          <path className="homie_logo_rectangle" d="M93.5375489,6.26182484e-05 L93.5375489,0.0019411657 L66.6119365,0.0019411657 L66.6119365,6.26182484e-05 L62.7834334,6.26182484e-05 L62.7834334,13.5240388 L66.6119365,13.5240388 L66.6119365,3.84951944 L93.5375489,3.84951944 L93.5375489,30.925337 L79.59186,30.925337 L79.59186,34.771976 L97.3370977,34.771976 L97.3370977,34.7466156 L97.3672973,34.7466156 L97.3672973,6.26182484e-05 L93.5375489,6.26182484e-05 Z" />
          <path className="homie_logo_letter_h" d="M10.4207388,18.8729835 L10.4207388,25.006754 L4.21518277,25.006754 L4.21518277,18.8729835 L0,18.8729835 L0,35.0388236 L4.21518277,35.0388236 L4.21518277,28.6398648 L10.4207388,28.6398648 L10.4207388,35.0388236 L14.6368556,35.0388236 L14.6368556,18.8729835 L10.4207388,18.8729835 Z" />
          <path className="homie_logo_letter_o" d="M24.875 22.322c-2.174 0-3.588 1.844-3.588 4.633 0 2.79 1.414 4.635 3.588 4.635 2.171 0 3.639-1.844 3.639-4.635 0-2.79-1.468-4.633-3.64-4.633zm0 12.98c-4.635 0-7.83-3.528-7.83-8.347 0-4.844 3.195-8.347 7.83-8.347 4.66 0 7.88 3.503 7.88 8.347 0 4.819-3.22 8.347-7.88 8.347z"/>
          <path className="homie_logo_letter_m" d="M42.442 35.039l-3.35-9.612v9.612h-3.93V18.873h5.133L43.83 28.93l3.509-10.057h5.106v16.166H48.49v-9.612l-3.324 9.612h-2.724z"/>
          <path className="homie_logo_letter_i" d="M55.508 35.039h4.215V18.873h-4.215v16.166z"/>
          <path className="homie_logo_letter_e" d="M74.281 18.873v3.633h-7.358v2.527h6.73v3.555h-6.73v2.791h7.358v3.66H62.786V18.873h11.495z"/>
        </svg>
      </ScreenModalBody>
    </ScreenOverlayCustom>
  )
}
